/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
// See scripts/generate-component-factory.js to modify the generation of this file.
import Accordion from '../components/Accordion';
import AuthorSetContent from '../components/Author-Set-Content';
import BlogCard from '../components/Blog-Card';
import Bodytext from '../components/Bodytext';
import Button from '../components/Button';
import CarrierBandSlides from '../components/Carrier-Band-Slides';
import ContactCard from '../components/Contact-Card';
import ContactSidebar from '../components/Contact-Sidebar';
import ContentBlock from '../components/ContentBlock';
import CostModule from '../components/Cost-Module';
import CrossSellPolicies from '../components/Cross-Sell-Policies';
import CustomerTestimonial from '../components/Customer-Testimonial';
import CustomImage from '../components/CustomImage';
import DynamicTable from '../components/Dynamic-Table';
import FeaturedContent from '../components/Featured-Content';
import H2 from '../components/H2';
import H2AndDescriptor from '../components/H2AndDescriptor';
import H2andIcon from '../components/H2andIcon';
import H3 from '../components/H3';
import H3andIcon from '../components/H3andIcon';
import H4 from '../components/H4';
import Heading from '../components/Heading';
import HomePageValueProp from '../components/HomePage-ValueProp';
import HorizontalScroller from '../components/HorizontalScroller';
import ImageWrapper from '../components/ImageWrapper';
import InlineCTA from '../components/Inline-CTA';
import LeadRoutingNumberAttribution from '../components/Lead-Routing-Number-Attribution';
import LinkWrapper from '../components/LinkWrapper';
import Media from '../components/Media';
import ModalCTA from '../components/Modal-CTA';
import MultiColumn from '../components/MultiColumn';
import Pagination from '../components/Pagination';
import PolicyCard from '../components/Policy-Card';
import PolicyCardList from '../components/PolicyCardList';
import PolicyDescription from '../components/PolicyDescription';
import Preview from '../components/Preview';
import PullQuote from '../components/Pull-Quote';
import QuoteLanding from '../components/Quote-Landing';
import RelatedPolicies from '../components/RelatedPolicies';
import SeriesValueProp from '../components/Series-Value-Prop';
import SidebarSection from '../components/SidebarSection';
import SocialSharing from '../components/Social-Sharing';
import SpecialList from '../components/Special-List';
import StateModule from '../components/State-Module';
import TabbedFeature from '../components/TabbedFeature';
import Table from '../components/Table';
import Testimonial from '../components/Testimonial';
import TrustImage from '../components/Trust-Image';
import TrustPilotWidget from '../components/TrustPilot-Widget';
import Typography from '../components/Typography';
import UniversalRouter from '../components/UniversalRouter';
import ValueProp from '../components/ValueProp';
import Video from '../components/Video';
import VideoComponent from '../components/VideoComponent';
import VideoComponentWithList from '../components/VideoComponentWithList';

const components = new Map();
components.set('Accordion', Accordion);
components.set('Author-Set-Content', AuthorSetContent);
components.set('Blog-Card', BlogCard);
components.set('Bodytext', Bodytext);
components.set('Button', Button);
components.set('Carrier-Band-Slides', CarrierBandSlides);
components.set('Contact-Card', ContactCard);
components.set('Contact-Sidebar', ContactSidebar);
components.set('ContentBlock', ContentBlock);
components.set('Cost-Module', CostModule);
components.set('Cross-Sell-Policies', CrossSellPolicies);
components.set('Customer-Testimonial', CustomerTestimonial);
components.set('CustomImage', CustomImage);
components.set('Dynamic-Table', DynamicTable);
components.set('Featured-Content', FeaturedContent);
components.set('H2', H2);
components.set('H2AndDescriptor', H2AndDescriptor);
components.set('H2andIcon', H2andIcon);
components.set('H3', H3);
components.set('H3andIcon', H3andIcon);
components.set('H4', H4);
components.set('Heading', Heading);
components.set('HomePage-ValueProp', HomePageValueProp);
components.set('HorizontalScroller', HorizontalScroller);
components.set('ImageWrapper', ImageWrapper);
components.set('Inline-CTA', InlineCTA);
components.set('Lead-Routing-Number-Attribution', LeadRoutingNumberAttribution);
components.set('LinkWrapper', LinkWrapper);
components.set('Media', Media);
components.set('Modal-CTA', ModalCTA);
components.set('MultiColumn', MultiColumn);
components.set('Pagination', Pagination);
components.set('Policy-Card', PolicyCard);
components.set('PolicyCardList', PolicyCardList);
components.set('PolicyDescription', PolicyDescription);
components.set('Preview', Preview);
components.set('Pull-Quote', PullQuote);
components.set('Quote-Landing', QuoteLanding);
components.set('RelatedPolicies', RelatedPolicies);
components.set('Series-Value-Prop', SeriesValueProp);
components.set('SidebarSection', SidebarSection);
components.set('Social-Sharing', SocialSharing);
components.set('Special-List', SpecialList);
components.set('State-Module', StateModule);
components.set('TabbedFeature', TabbedFeature);
components.set('Table', Table);
components.set('Testimonial', Testimonial);
components.set('Trust-Image', TrustImage);
components.set('TrustPilot-Widget', TrustPilotWidget);
components.set('Typography', Typography);
components.set('UniversalRouter', UniversalRouter);
components.set('ValueProp', ValueProp);
components.set('Video', Video);
components.set('VideoComponent', VideoComponent);
components.set('VideoComponentWithList', VideoComponentWithList);

export default function componentFactory(componentName) {
  return components.get(componentName);
};
